import { render } from "./MyPurchasedDigitalProducts.vue.js?vue&type=template&id=1ee47401!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyPurchasedDigitalProducts.vue?vue&type=template&id=1ee47401"
import script from "./MyPurchasedDigitalProducts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyPurchasedDigitalProducts.vue?vue&type=script&lang=js"
export * from "./MyPurchasedDigitalProducts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyPurchasedDigitalProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/MyPurchasedDigitalProducts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ee47401"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ee47401', __exports__)) {
    api.reload('1ee47401', __exports__)
  }
  
  module.hot.accept("./MyPurchasedDigitalProducts.vue.js?vue&type=template&id=1ee47401!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyPurchasedDigitalProducts.vue?vue&type=template&id=1ee47401", () => {
    api.rerender('1ee47401', render)
  })

}


export default __exports__